module.exports = __webpack_public_path__ + "static/media/tag@3x-ticket-nick.e73a9b51.png";